import axios from 'axios'
import Cookie from 'js-cookie'
import { v4 as uuid } from 'uuid'
import { isString } from 'underscore'


if (window.XMLHttpRequest) {
  let requestStack = { };
  let defaultOpenFunction = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function(method, url, async, user, pass) { // eslint-disable-line
    window.document.body.dispatchEvent(new Event('mailbox-request'));

    let requestData = {
      uuid: uuid(),
      requestString: `${method} ${url}`
    };
    requestStack[requestData.uuid] = requestData;

    this.addEventListener('readystatechange', () => {
      if (this.readyState == 4) {
        delete requestStack[requestData.uuid];
        if (Object.keys(requestStack).length === 0) {
          window.document.body.dispatchEvent(new Event('mailbox-requests-done'));
        }
      }
    }, false);

    defaultOpenFunction.apply(this, Array.prototype.slice.call(arguments));
  };
}


let headers = {
  'Content-Type': 'application/json'
};

let token = Cookie.get('__ec_accessToken');
if (token) {
  headers.Authorization = `Bearer ${token}`;
}

let client = axios.create({
  baseURL: '/api/v2/',
  headers: headers
});

export function setBearerToken(token) {
    client.defaults.headers['Authorization'] = `Bearer ${token}`;
}

export const HTTP = client;

export const clientFactory = {
    create(token) {
        let headers = {
            'Content-Type': 'application/json'
        };

        if (isString(token) && '' !== token) {
            headers.Authorization = `Bearer ${token}`;
        }

        return axios.create({
            baseURL: '/api/v2/',
            headers: headers
        });
    }
};
